module.exports = __webpack_public_path__ + "static/media/department-of-transport.f120535b.png";